import React, { useState, useEffect, useContext, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./css/CategoryReg.css";
import "bootstrap/dist/css/bootstrap.css";
import SideNav from "./SideNav";
import TopRootDiv from "./TopRootDiv";
import SherDineNav from "./SherDineNav";
import { DBContext } from "./DBContext";
import edit from "./images/MenuReg/Editing1.png";
import tick from "./images/icons/check.png";
import cross from "./images/icons/cross.png";
import axios from "axios";
import io from 'socket.io-client';


function CategoryReg() {
  const [collapsed, setCollapsed] = useState(false);
  const [CategoryName, setCategoryName] = useState("");
  const [CategoryCode, setCategoryCode] = useState("");
  const [Database, setDatabase] = useState(localStorage.getItem("DB"));
  const [imgCode, setImgCode] = useState(localStorage.getItem("imgCode"));
  const [company, setCompany] = useState(localStorage.getItem("Company"));

  const location = useLocation(null);

  const [item, setItem] = useState({});

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };
  const api_base_url = process.env.REACT_APP_API_BASE_URL;

  const { logginedDB, user_Id } = useContext(DBContext);

  const [categoryCodeOldToUpdate, setCategoryCodeOldToUpdate] = useState(null);

  const [categoryId, setCategoryId] = useState(null);
  const [category, setCategory] = useState(null);
  
  // State to track initial values for change detection in Edit Mode
  const [initialCategoryName, setInitialCategoryName] = useState("");
  const [initialCategoryCode, setInitialCategoryCode] = useState("");

  useEffect(() => {
    if (location.state) {
      setCategoryId(location.state.id);
      setCategory(location.state.category);
    }
  }, [location]);
  

  const currentDate = new Date().toISOString().split("T")[0];

  const formatTime = () => {
    let now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert 24-hour to 12-hour format
    minutes = minutes.toString().padStart(2, "0"); // Ensure two-digit minutes
    return `${hours}:${minutes} ${ampm}`;
  };

  const eventDetails = {
    ddate: currentDate,
    ttime: formatTime(),
    user_Id: user_Id, // Replace with actual user ID variable
    // user: userName // Replace with actual user variable
  };

  const handleSubmit = async () => {
    // 1. Basic Validation: Check for empty fields
    const nameStr = (CategoryName || "").trim();
    const codeStr = (CategoryCode || "").toString().trim();

    if (!nameStr || !codeStr) {
      alert("Please fill in all fields.");
      return;
    }

    // 2. Edit Mode Specific Validation
    if (categoryId) {
      const isNameChanged = nameStr !== initialCategoryName;
      const isCodeChanged = codeStr !== initialCategoryCode;

      // Check if NO changes were made
      if (!isNameChanged && !isCodeChanged) {
        alert("No changes found");
        return;
      }

      // If Name changed, it must be available (avail === 1 means available)
      if (isNameChanged && avail !== 1) {
         // If avail is null (check hasn't finished) or 0 (taken), block it.
         // Note: avail is null if check didn't run (e.g. user typed fast or network lag), 
         // but strictly we expect avail=1 for a valid new name.
         // However, if the user didn't change the name, we shouldn't check avail.
         alert("Category Name already exists or is invalid.");
         return;
      }

      // If Code changed AND it's manually editable/enabled
      if (isCodeChanged && !codeDisable) {
          if (availCode !== 1) {
             alert("Category Code already exists or is invalid.");
             return;
          }
      }
    } else {
      // 3. Add Mode Validation
      // Name must be available
      if (avail !== 1) {
        alert("Category Name already exists or is invalid.");
        return;
      }
      
      // If code is manually enabled, it must be available. 
      // If code is auto-generated (codeDisable is true), we assume logic elsewhere handled it (or availCode check might be needed if auto-gen collides).
      // Typically auto-code is safe, but if user manually typed, check availCode.
      if (!codeDisable && availCode !== 1) {
         alert("Category Code already exists or is invalid.");
         return;
      }
      
       // Additional safety: if even auto-code has a collision status (if logic updates availCode), check it.
       // But usually `availCode` updates only on manual change or explicit check.
    }

    const today = new Date();

    const data = {
      CategoryName: nameStr,
      CategoryCode: codeStr,
      Date: today,
    };

    let response;

    try {
      if (categoryId) {
        response = await fetch(
          `${api_base_url}/CategoryRegUpdate/${categoryId}/${categoryCodeOldToUpdate}/${logginedDB}/${JSON.stringify(
            eventDetails
          )}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          }
        );
      } else {
        response = await fetch(
          `${api_base_url}/CategoryReg/${logginedDB}/${JSON.stringify(
            eventDetails
          )}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          }
        );
      }

      if (response.ok) {
        //("Data submitted successfully");
        // Optionally, reset the form fields here
        setCategoryName("");
        setCategoryCode("");
        navigate("/Basemenureg", {
          state: "CategoryCancel",
        });
      } else {
        console.error("Failed to submit data");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  // if (productID) {
  //     handleSubmit();
  // }

  const handleCategoryNameChange = (event) => {
    const val = event.target.value;
    setCodeDisable(true);
    setCategoryName(val);
    handleCheckAvailableName(val);
  };
  //(company, "FGHJK");
  const handleCategoryCodeChange = (event) => {
    const val = event.target.value;
    setCategoryCode(val);
    handleCheckAvailableCode(val);
  };

  useEffect(() => {
    const handleWindowResize = () => {
      if (window.innerWidth <= 768) {
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const navigate = useNavigate();

  const handleCancel = () => {
    navigate("/basemenureg", {
      state: "CategoryCancel",
    });
  };

  const handleSaveArea = () => {};

  const [sideNav, setSideNav] = useState(false);
  const handleSideNav = (state) => {
    setSideNav(state);
  };
  const [falseState, setFalseState] = useState(null);

  const [avail, setAvail] = useState(null);
  const [availCode, setAvailCode] = useState(null);
  const [autoCategoryCode, setAutoCategoryCode] = useState(null);
  const [codeDisable, setCodeDisable] = useState(true);

  const handleModifyCategory = async () => {
    try {
      const response = await axios.get(
        `${api_base_url}/getCategoryDetails/${categoryId}/${logginedDB}`
      );
      if (response.status == 200) {
        setCategoryName(response.data[0].Category_Name);
        setCategoryCode(response.data[0].Category_Code);
        setCategoryCodeOldToUpdate(response.data[0].id_category);
        
        // Set initial values
        setInitialCategoryName(response.data[0].Category_Name);
        setInitialCategoryCode(response.data[0].Category_Code);
      }
    } catch (error) {
      //(error);
    }
  };

  useEffect(() => {
    if (categoryId) {
      handleModifyCategory();
    }
  }, [categoryId]);

  function getInitialsUppercase(str) {
    if (!str) return ""; // Handle empty or null strings
    return str
      .split(" ") // Split the string into words
      .map((word) => word[0]?.toUpperCase() || "") // Get the first letter of each word in uppercase
      .join(""); // Join the initials into a single string
  }

  const handleAutoCategoryCode = async (val) => {
    const code = getInitialsUppercase(val);
    try {
      const response = await axios.get(
        `${api_base_url}/autoCategoryCode/${code}/${logginedDB}`
      );
      if (response.status === 200) {
        const codeAvail = response.data.nextAvailableCode;
        setAutoCategoryCode(codeAvail);
        setCategoryCode(codeAvail);
      }
    } catch (error) {
      //(error);
    }
  };

  const handleCheckAvailableCode = async (val) => {
    if (val === "") return setAvailCode(null);
    try {
      const response = await axios.get(
        `${api_base_url}/checkAvailablityCategoryCode/${val}/${logginedDB}`
      );
      if (response.status === 200) {
        const checked = response.data.isAvailable;

        if (checked == 0) {
          setAvailCode(1);
        } else {
          setAvailCode(0);
        }
      }
    } catch (error) {
      //(error);
    }
  };

  const handleCheckAvailableName = async (val) => {
    if (val === "") return setAvail(null);
    try {
      const response = await axios.get(
        `${api_base_url}/checkAvailablityCategory/${val}/${logginedDB}`
      );
      if (response.status === 200) {
        const checked = response.data.isAvailable;
        if (checked == 0) {
          setAvail(1);
          handleAutoCategoryCode(val);
        } else {
          setAvail(0);
          setAutoCategoryCode(null);
        }
      }
    } catch (error) {
      //(error);
    }
  };

  


  const handleModifyCategoryCode = async () => {
    const userConfirmed = window.confirm(`Custom Category code ?`);

    if (!userConfirmed) {
      return;
    }
    handleCheckAvailableCode(availCode);
    setCodeDisable(false);
  };

  return (
    <div className="CategoryRegMainDiv">
      <SherDineNav
        sideNav={(state) => handleSideNav(state)}
        falseState={falseState}
      />
      <div className="CategoryRegContentDiv flex gap-3">
        <SideNav
          focus={"Menu"}
          state={sideNav}
          falseState={(state) => setFalseState(state)}
        />
        <div className="CategoryRegContentSideBarRight">
          <div className="CategoryRegSidebar">
            <TopRootDiv
              image={"Menu Management"}
              root={["Menu Management", "Base Menu"]}
              section={"Add Category"}
            />
          </div>
          <div className="Container_Menu CategoryRegForm flex flex-col h-full pt-3">
            <div className="CategoryAreaReg_areaDetails_span bg-white rounded-t-md border-b">
              <span>Category Details</span>
              <div className=" AddItem_Buttons AddItem_Buttons_CategoryAreaReg">
                <button
                  className="loginBorder text-[#0008B4] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button
                  className="loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3"
                  onClick={handleSubmit}
                >
                  Save
                </button>
              </div>
            </div>
            {/* <div className='CategoryRegForm_Contents '> */}
            <div className="w-full flex flex-col sm:flex-row bg-white p-4 gap-4 flex-grow h-full rounded-b-md shadow-sm border border-t-0 border-gray-200">
              <div className="flex flex-col w-1/2 gap-1">
                <span>Category Name</span>
                {/* <input className="p-2 h-[2.rem]" type="text" value={CategoryName} onChange={handleCategoryNameChange} /> */}
                <div className="w-full flex areaBorder h-[2.5rem] rounded-[.313rem]">
                  <input
                    className="w-full h-auto border-0 p-2"
                    type="text"
                    value={CategoryName}
                    onChange={handleCategoryNameChange}
                  />
                  <div className="w-max flex justify-center items-center p-2">
                    {avail == 1 && (
                      <img className="w-[1.25rem]" src={tick} alt="" />
                    )}
                    {avail == 0 && (
                      <img className="w-[1.25rem]" src={cross} alt="" />
                    )}
                  </div>
                </div>
              </div>
              <div className="flex flex-col w-1/2 gap-1">
                <span>Category Code</span>
                {/* <input className="p-2 h-[2.5rem]" type="text" value={CategoryCode} onChange={handleCategoryCodeChange} /> */}
                <div
                  className={`w-full flex h-[2.5rem] areaBorder rounded-[.313rem] ${
                    codeDisable ? "bg-slate-100" : ""
                  }`}
                >
                  <input
                    className="w-full h-auto border-0 KitchenCode p-2"
                    type="text"
                    value={
                      CategoryName !== "" && avail == 1 && codeDisable
                        ? autoCategoryCode
                        : !codeDisable
                        ? CategoryCode
                        : categoryId
                        ? CategoryCode
                        : ""
                    }
                    disabled={codeDisable}
                    onChange={handleCategoryCodeChange}
                  />
                  {CategoryName !== "" &&
                    autoCategoryCode &&
                    avail == 1 &&
                    codeDisable && (
                      <div className="w-max flex justify-center items-center p-2">
                        <img
                          className="w-[1.25rem] cursor-pointer"
                          src={edit}
                          alt=""
                          onClick={handleModifyCategoryCode}
                        />
                      </div>
                    )}
                  {!codeDisable && (
                    <div className="w-max flex justify-center items-center p-2">
                      {availCode == 1 && (
                        <img className="w-[1.25rem]" src={tick} alt="" />
                      )}
                      {availCode == 0 && (
                        <img className="w-[1.25rem]" src={cross} alt="" />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CategoryReg;
